import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/source-systems`;

export const sourceSystemService = {
  list: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.system_type) params.append('system_type', filters.system_type);
    if (filters.is_active !== undefined) params.append('is_active', filters.is_active);
    const response = await axios.get(`${API_BASE}?${params}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  register: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  deactivate: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  testConnection: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/test-connection`);
    return response.data;
  },

  triggerSync: async (id) => {
    // The connector extracts all flows and pushes them through the ELM pipeline,
    // so allow plenty of time (cold start + AI mapping + validation).
    const response = await axios.post(`${API_BASE}/${id}/sync`, {}, { timeout: 130000 });
    return response.data;
  },

  routeCorrection: async (id, data) => {
    const response = await axios.post(`${API_BASE}/${id}/route-correction`, data);
    return response.data;
  },

  getFiles: async (id, filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);
    const response = await axios.get(`${API_BASE}/${id}/files?${params}`);
    return response.data;
  },

  getStatistics: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}/statistics`);
    return response.data;
  },

  getSensorHistory: async (sourceSystemId, hours = 24) => {
    const response = await axios.get(`/api/rtdip-sensors/${sourceSystemId}/history?hours=${hours}`);
    return response.data;
  }
};

export default sourceSystemService;
